import * as React from "react";

import axios from "axios";
import { useDispatch } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import MuiButton from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";

import ResetIcon from "@material-ui/icons/Replay";

import { showNotification } from "jazasoft";

import { authServerUrl as authUrl } from "../../App";
import { useSafeState } from "../../hooks";
import handleError from "../../utils/handleError";

const useStyles = makeStyles({
    root: {
        display: "inline-block",
    },
    width: {
        width: 400,
    },
});

const ResetButton = ({ ...props }) => {

    const username = props?.record?.username;

    console.log({ props })
    const classes = useStyles();
    const [password, setPassword] = useSafeState("");
    const [confirmPassword, setConfirmPassword] = useSafeState("");
    const [dialogActive, setDialogActive] = useSafeState(false);
    const [busy, setBusy] = useSafeState(false);

    const dispatch = useDispatch();


    const handleClose = async event => {
        setDialogActive(false);
    };

    const handleSubmit = async event => {
        if (password !== confirmPassword) {
            dispatch(showNotification("Passwords do not match.", { type: "danger" }));
            return;
        };

        const options = {
            url: `${authUrl}/users/resetPassword`,
            method: "put",
            params: { username, newPassword: password },
            headers: { "Authorization": "Bearer" + localStorage.getItem('access_token_optacut') },
        };

        try {
            setBusy(true);
            const response = await axios.request(options);
            if (response.status === 200) {
                dispatch(showNotification(`Passwordreset successfully.`));
                setPassword('');
                setConfirmPassword('');
            }
            setBusy(false);
            setDialogActive(false);
        } catch (error) {
            handleError(error, dispatch);
            setBusy(false);
            setDialogActive(false);
            setPassword('');
            setConfirmPassword('');

        }

        setDialogActive(false);
    };

    return (
        <div className={classes.root}>
            <Dialog open={dialogActive} onClose={handleClose}>
                <DialogTitle className={classes.width}>Reset Password</DialogTitle>

                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="password"
                        label="New Password"
                        type="password"
                        fullWidth
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                    />

                    <TextField
                        margin="dense"
                        id="confirmPassword"
                        label="Confirm Password"
                        type="password"
                        fullWidth
                        value={confirmPassword}
                        onChange={e => setConfirmPassword(e.target.value)}
                    />

                </DialogContent>

                <DialogActions>
                    <MuiButton onClick={handleClose} color="primary" variant="text">
                        Cancel
                    </MuiButton>
                    <MuiButton
                        onClick={handleSubmit}
                        color="primary"
                        variant="contained"
                        autoFocus
                        disabled={busy || password?.length < 4}>
                        Submit
                    </MuiButton>
                </DialogActions>
            </Dialog>

            <MuiButton
                onClick={() => setDialogActive(true)}
                className={classes.deleteButton}
                variant="outlined"
                startIcon={<ResetIcon />}
                {...props}>
                Reset Password
            </MuiButton>
        </div>
    );
};

export default ResetButton;
